import { useEffect, useRef, useState } from "react";
import {
  Icon,
  InputDropdown,
  InputField,
  Text,
  Button,
  InputDate,
  InputCheckbox,
  InputTextarea,
  Container,
  InputRadio,
  AvatarV2,
} from "@jds/core";
import classes from "./DynamicForm.module.css";
import JdsModal from "../UI/JdsModal";
import TextInputForm from "./InputForms/TextInputForm";
import DropDownInputForm from "./InputForms/DropDownInputForm";
import RadioInputFrom from "./InputForms/RadioInputFrom";
import CheckboxInputForm from "./InputForms/CheckboxInputForm";
import ParagraphInputForm from "./InputForms/ParagraphInputForm";
import DateInputForm from "./InputForms/DateInputForm";
import textsvg from "../../assets/svg/text.svg";
import radiosvg from "../../assets/svg/radio.svg";
import dropdownsvg from "../../assets/svg/dropdown.svg";
import checksvg from "../../assets/svg/checkbox.svg";
import datesvg from "../../assets/svg/date.svg";
import parasvg from "../../assets/svg/para.svg";
import ConsentInputForm from "./InputForms/ConsentInputForm";
import { useSelector } from "react-redux";
const DynamicForm = ({ defaultDynamicField = [], setDefaultDynamicField }) => {
  const profileDetailsRedux = useSelector(
    (state) => state.profileDetails.profileDetails,
  );
  //Change the child state use parent props default
  const inputItems = defaultDynamicField;
  const setInputItems = setDefaultDynamicField;
  // const [inputItems, setInputItems] = useState([]);
  const [textInputModal, setTextInputModal] = useState(true);
  const [dropDownInputModal, setDropDownInputModal] = useState(true);
  const [radioInputModal, setRadioInputModal] = useState(true);
  const [paragraphInputModal, setParagraphInputModal] = useState(true);
  const [dateInputModal, setDateInputModal] = useState(true);
  const [checkboxInputModal, setCheckboxInputModal] = useState(true);
  const [consentInputModal, setConsentInputModal] = useState(true);
  const [isDeleteModalClose, setDeleteModalClose] = useState(true);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [editData, setEditData] = useState(null);
  const [radioHandle, setRadioHandle] = useState({});
  const dragItem = useRef(null);
  const dragOverItem = useRef(null);

  const [isDragging, setIsDragging] = useState(false);

  const handleDragStart = (e) => {
    e.dataTransfer.setData("input", e.target.id);
    setIsDragging(true);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const id = e.dataTransfer.getData("input");
    if (inputItems.length < 5) {
      if (id === "text") {
        setTextInputModal(false);
      }
      if (id === "dropdown") {
        setDropDownInputModal(false);
      }
      if (id === "radio") {
        setRadioInputModal(false);
      }
      if (id === "date") {
        setDateInputModal(false);
      }
      if (id === "checkbox") {
        setCheckboxInputModal(false);
      }
      if (id === "paragraph") {
        setParagraphInputModal(false);
      }
      if (id === "consent") {
        setConsentInputModal(false);
      }
    }
    setIsDragging(false);
  };

  const handleDragEnd = () => {
    setIsDragging(false); // Ensure dragging state is reset when dragging ends
  };

  const inputFieldsRender = (item) => {
    switch (item.type) {
      case "text":
        return (
          <InputField
            label={`${item.questionName} ${item.required ? "*" : ""}`}
          />
        );
      case "dropdown":
        return (
          <InputDropdown
            label={`${item.questionName} ${item.required ? "*" : ""}`}
            items={item.options?.map((val) => {
              return {
                label: val,
                value: val,
              };
            })}
          />
        );

      case "date":
        return (
          <InputDate
            label={`${item.questionName} ${item.required ? "*" : ""}`}
          />
        );
      case "checkbox":
        return (
          <div style={{ width: "100%" }}>
            <Container direction="column" fullWidth>
              <Text
                text={`${item.questionName} ${item.required ? "*" : ""}`}
                appearance="body-xs"
                color="primary_grey_80"
              />
              <Container
                gap={40}
                fullWidth
                style={{
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}>
                <Container fullWidth direction="column" gap={8}>
                  {item.options?.map((val) => (
                    <InputCheckbox
                      label={
                        <Text
                          text={`${val}`}
                          appearance="body-xs"
                          color="primary_grey_80"
                        />
                      }
                      size="small"
                    />
                  ))}
                </Container>
              </Container>
            </Container>
          </div>
        );

      case "consent":
        return (
          <div style={{ width: "100%" }}>
            <InputCheckbox
              label={
                <Text
                  text={`${item.questionName} ${item.required ? "*" : ""}`}
                  appearance="body-xs"
                  color="primary_grey_80"
                />
              }
              size="small"
            />
          </div>
        );

      case "paragraph":
        return (
          <>
            <InputTextarea
              rows={2}
              label={`${item.questionName} ${item.required ? "*" : ""}`}
            />
          </>
        );
      case "radio":
        return (
          <>
            <Container direction="column" fullWidth>
              <Text
                text={`${item.questionName} ${item.required ? "*" : ""}`}
                appearance="body-xs"
                color="primary_grey_80"
              />
              <Container
                gap={10}
                fullWidth
                style={{
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}>
                {item.options?.map((val) => (
                  <InputRadio
                    label={val}
                    suffix="ic_profile"
                    prefix="ic_profile"
                    size="small"
                    checked={radioHandle[item.id] === val ? true : false}
                    onChange={() => {
                      setRadioHandle((pre) => {
                        return { ...pre, [item.id]: val };
                      });
                    }}
                  />
                ))}{" "}
              </Container>
            </Container>
          </>
        );

      default:
        return <></>;
    }
  };

  const handleSort = () => {
    const _inputItems = [...inputItems];
    const temp = _inputItems[dragItem.current];
    _inputItems[dragItem.current] = _inputItems[dragOverItem.current];
    _inputItems[dragOverItem.current] = temp;
    dragItem.current = null;
    dragOverItem.current = null;
    setInputItems(_inputItems);
  };

  const tools = [
    {
      id: "text",
      img: textsvg,
      label: "Text",
    },
    {
      id: "dropdown",
      img: dropdownsvg,
      label: "Dropdown",
    },
    {
      id: "radio",
      img: radiosvg,
      label: "Radio",
    },
    // {
    //   id: "date",
    //   img: datesvg,
    //   label: "Date",
    // },
    {
      id: "checkbox",
      img: checksvg,
      label: "Checkbox",
    },
    // {
    //   id: "consent",
    //   img: checksvg,
    //   label: "Consent",
    // },
    // {
    //   id: "paragraph",
    //   img: parasvg,
    //   label: "Paragraph",
    // },
  ];

  // useEffect(() => {
  //   Array.isArray(defaultDynamicField)
  //     ? setInputItems(defaultDynamicField)
  //     : setInputItems([]);
  // }, [defaultDynamicField]);
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}>
        <div
          style={{
            display: "flex",
            background: "#f5f5f5",
            padding: "10px",
            borderRadius: "5px",
            gap: "10px",
          }}>
          <Icon ic={"IcWarning"} color="primary_grey_80" />
          <p>
            These fields are required for the{" "}
            {profileDetailsRedux?.userType === "SCHOOL" ? "student" : "guest"}{" "}
            information form. You can add 5 more fields by dragging and dropping
            from the tools in the right panel.
          </p>
        </div>
        <div className={`${classes["grid-container"]}`}>
          {isDragging && (
            <div
              className={`${classes["drag-div"]}`}
              onDragOver={handleDragOver}
              onDrop={handleDrop}>
              Drop the field
            </div>
          )}
          {!isDragging && (
            <div className={`${classes["drag-div-items"]} custom-scrollbar`}>
              {/* <AvatarV2 avatarKind={"icon"} isClickable={false} /> */}
              <InputField label="First Name *" disabled={true} />
              <InputField label="Last Name *" disabled={true} />
              {/* <InputField label="Phone Number  *" disabled={true} /> */}
              <InputField label="Email" disabled={true} />
              <br />
              <div>
                {inputItems.map((item, index) => (
                  <div
                    style={{
                      display: "flex",
                      gap: "20px",
                      alignItems: "end",
                      marginBottom: "20px",
                    }}
                    draggable
                    onDragStart={(e) => {
                      dragItem.current = index;
                    }}
                    onDragEnd={handleSort}
                    onDragEnter={() => (dragOverItem.current = index)}
                    onDragOver={(e) => e.preventDefault()}>
                    <Icon ic={"IcBurgerMenu"} color="primary_grey_80" />
                    {inputFieldsRender(item)}
                    <Icon
                      ic={"IcEditPen"}
                      onClick={() => {
                        setEditData({ ...item, index });
                        if (item.type === "text") {
                          setTextInputModal(false);
                        }
                        if (item.type === "dropdown") {
                          setDropDownInputModal(false);
                        }
                        if (item.type === "radio") {
                          setRadioInputModal(false);
                        }
                        if (item.type === "date") {
                          setDateInputModal(false);
                        }
                        if (item.type === "checkbox") {
                          setCheckboxInputModal(false);
                        }
                        if (item.type === "paragraph") {
                          setParagraphInputModal(false);
                        }
                        if (item.type === "consent") {
                          setConsentInputModal(false);
                        }
                        //   setInputItems((pre) => pre.filter((_, i) => i !== index));
                      }}
                    />
                    <Icon
                      ic={"IcTrash"}
                      onClick={() => {
                        setDeleteModalClose(false);
                        setDeleteIndex(index);
                      }}
                      color="secondary_50"
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
          <div>
            <div className={`${classes["input-fields"]}`}>
              {tools?.map((item, index) => (
                <div
                  className={`${classes["input-fields-item"]}`}
                  draggable={inputItems.length < 5 ? true : false}
                  id={item.id}
                  onDragStart={handleDragStart}
                  onDragEnd={handleDragEnd}
                  style={{
                    cursor: inputItems.length < 5 ? "move" : "no-drop",
                  }}>
                  <img
                    src={item.img}
                    style={{ width: "35px" }}
                    draggable={false}
                  />
                  <p>{item.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* Delete conformation modal */}

      <JdsModal
        size="m"
        header="Are you sure you want to remove the field?"
        kind="dialog"
        primaryCTA={{
          title: "Okay",
        }}
        secondaryCTA={{
          title: "Cancel",
        }}
        close={isDeleteModalClose}
        onClose={() => {
          setDeleteModalClose(true);
          setDeleteIndex(null);
        }}
        onPrimaryClick={() => {
          setInputItems((pre) => pre.filter((_, i) => i !== deleteIndex));
          setDeleteModalClose(true);
          setDeleteIndex(null);
        }}
        onSecondaryClick={() => {
          setDeleteIndex(null);
          setDeleteModalClose(true);
        }}
      />

      {/* Text Input Modal */}
      <JdsModal
        header="Text Field"
        close={textInputModal}
        onClose={() => {
          setTextInputModal(true);
        }}
        size="m">
        {!textInputModal && (
          <TextInputForm
            onSuccess={(obj) => {
              setInputItems((pre) => [...pre, obj]);
            }}
            editData={editData}
            setEditData={setEditData}
            editSuccess={(obj, index) => {
              let _inputItems = [...inputItems];
              _inputItems[index] = obj;
              setInputItems(_inputItems);
            }}
          />
        )}
      </JdsModal>
      {/* DropDown Input Modal */}
      <JdsModal
        header="DropDown Field"
        close={dropDownInputModal}
        onClose={() => {
          setDropDownInputModal(true);
        }}
        size="m">
        {!dropDownInputModal && (
          <DropDownInputForm
            onSuccess={(obj) => {
              setInputItems((pre) => [...pre, obj]);
            }}
            editData={editData}
            setEditData={setEditData}
            editSuccess={(obj, index) => {
              let _inputItems = [...inputItems];
              _inputItems[index] = obj;
              setInputItems(_inputItems);
            }}
          />
        )}
      </JdsModal>

      {/* Radio Input Modal */}
      <JdsModal
        header="Radio Field"
        close={radioInputModal}
        onClose={() => {
          setRadioInputModal(true);
        }}
        size="m">
        {!radioInputModal && (
          <RadioInputFrom
            onSuccess={(obj) => {
              setInputItems((pre) => [...pre, obj]);
            }}
            editData={editData}
            setEditData={setEditData}
            editSuccess={(obj, index) => {
              let _inputItems = [...inputItems];
              _inputItems[index] = obj;
              setInputItems(_inputItems);
            }}
          />
        )}
      </JdsModal>

      {/* Checkbox Input Modal */}
      <JdsModal
        header="Checkbox Field"
        close={checkboxInputModal}
        onClose={() => {
          setCheckboxInputModal(true);
        }}
        size="m">
        {!checkboxInputModal && (
          <CheckboxInputForm
            onSuccess={(obj) => {
              setInputItems((pre) => [...pre, obj]);
            }}
            editData={editData}
            setEditData={setEditData}
            editSuccess={(obj, index) => {
              let _inputItems = [...inputItems];
              _inputItems[index] = obj;
              setInputItems(_inputItems);
            }}
          />
        )}
      </JdsModal>

      {/* Consent Input Modal */}
      <JdsModal
        header="Consent Field"
        close={consentInputModal}
        onClose={() => {
          setConsentInputModal(true);
        }}
        size="m">
        {!consentInputModal && (
          <ConsentInputForm
            onSuccess={(obj) => {
              setInputItems((pre) => [...pre, obj]);
            }}
            editData={editData}
            setEditData={setEditData}
            editSuccess={(obj, index) => {
              let _inputItems = [...inputItems];
              _inputItems[index] = obj;
              setInputItems(_inputItems);
            }}
          />
        )}
      </JdsModal>

      {/* Paragraph Input Modal */}
      <JdsModal
        header="Paragraph Field"
        close={paragraphInputModal}
        onClose={() => {
          setParagraphInputModal(true);
        }}
        size="m">
        {!paragraphInputModal && (
          <ParagraphInputForm
            onSuccess={(obj) => {
              setInputItems((pre) => [...pre, obj]);
            }}
            editData={editData}
            setEditData={setEditData}
            editSuccess={(obj, index) => {
              let _inputItems = [...inputItems];
              _inputItems[index] = obj;
              setInputItems(_inputItems);
            }}
          />
        )}
      </JdsModal>

      {/* Date Input Modal */}
      <JdsModal
        header="Date Field"
        close={dateInputModal}
        onClose={() => {
          setDateInputModal(true);
        }}
        size="m">
        {!dateInputModal && (
          <DateInputForm
            onSuccess={(obj) => {
              setInputItems((pre) => [...pre, obj]);
            }}
            editData={editData}
            setEditData={setEditData}
            editSuccess={(obj, index) => {
              let _inputItems = [...inputItems];
              _inputItems[index] = obj;
              setInputItems(_inputItems);
            }}
          />
        )}
      </JdsModal>
    </>
  );
};

export default DynamicForm;
